__turbopack_context__.v({
  "calloutSection": "PlasmicHome-module__f2QK0a__calloutSection",
  "contactModal": "PlasmicHome-module__f2QK0a__contactModal",
  "footer": "PlasmicHome-module__f2QK0a__footer",
  "header": "PlasmicHome-module__f2QK0a__header",
  "homeBenefitsSection": "PlasmicHome-module__f2QK0a__homeBenefitsSection",
  "homeCaseStudiesSection": "PlasmicHome-module__f2QK0a__homeCaseStudiesSection",
  "homeLoginSection": "PlasmicHome-module__f2QK0a__homeLoginSection",
  "homeProductsSection": "PlasmicHome-module__f2QK0a__homeProductsSection",
  "homeSolutionsSection": "PlasmicHome-module__f2QK0a__homeSolutionsSection",
  "homeTopSection": "PlasmicHome-module__f2QK0a__homeTopSection",
  "root": "PlasmicHome-module__f2QK0a__root",
  "serviceMessage": "PlasmicHome-module__f2QK0a__serviceMessage",
});
